import { Component, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss']
})
export class DownloadAppComponent {
  showQr = false;

  appFeatures = [
    { title: 'Stories', desc: 'Plain-language daily briefings for your block — no jargon, just what\'s coming and what to do.' },
    { title: 'RouteCast', desc: 'Hour-by-hour weather at every point along your journey, not just the destination.' },
    { title: 'Multi-Hazard Intelligence', desc: '6 hazard modules — heat, rain, fog, lightning, wind & humidity — updated continuously.' },
    { title: 'Climate Insight', desc: 'A decade of block-level climate history, paired with seismic, cyclone & infrastructure risk data.' },
    { title: 'GIS Layers', desc: 'Live hazard maps with a time-playback slider to see conditions evolve hour by hour.' }
  ];

  constructor(private elRef: ElementRef) { }

  toggleQr(event: Event) {
    event.stopPropagation();
    this.showQr = !this.showQr;
  }

  closeQr() {
    this.showQr = false;
  }

  // close when clicking anywhere outside the button / popup
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (this.showQr && !this.elRef.nativeElement.contains(event.target)) {
      this.showQr = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.showQr = false;
  }
}
